import React from "react";
import PropTypes from "prop-types";
import PopoverMenu from "../BatchdailerMenu/PopoverMenu";
import SVG from "components/base/SVG";
import classNames from "classnames";

import css from "./style.scss";

function WithDropdown({ items, title, icon, variant }) {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  return (
    <button
      className={classNames(css.menuIconWrapper, css.transparentButton, {
        [css.activeMenu]: isMenuOpen,
      })}
      onClick={() => setIsMenuOpen((prev) => !prev)}
    >
      <div className={css.actionIcon}>
        <SVG
          icon={isMenuOpen ? `${icon}-active` : `${icon}-inactive`}
          title={title}
          height={24}
          width={24}
        />
      </div>

      <PopoverMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        items={items}
        position="right"
        title={title}
        variant={variant}
      />
    </button>
  );
}

WithDropdown.propTypes = {
  items: PropTypes.array.isRequired,
  title: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

export default WithDropdown;
